/* eslint-disable */
import React from 'react'
import DetailsPage from 'flow/siteProposal/pages/details'

const MonitoringDetailsPage = () => {
 

  return (
    <div>
     <DetailsPage/>
    </div>
  )
}

export default MonitoringDetailsPage
